export class ApplicationPropertyErrorInfo {
    ApplicationId: string;
    ErrorCount: number;
    ErrorMessages: string[];
    AppPropertyErrorKeys: string[];
    DateUpdatedUtc?: Date;
}
